var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.emailRuleNullable,
      "label": _vm.$t('common.nouns.email'),
      "outlined": ""
    },
    model: {
      value: _vm.email,
      callback: function callback($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.$t('objects.person.billingProfile.paymentTerm'),
      "outlined": "",
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.value.paymentTerm,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "paymentTerm", _vm._n($$v));
      },
      expression: "value.paymentTerm"
    }
  }), _c('v-select', {
    attrs: {
      "label": _vm.$t('objects.contract.currency'),
      "hint": _vm.$t('objects.contract.currencyHint'),
      "persistent-hint": "",
      "items": Object.values(_vm.CurrencyEnum),
      "outlined": ""
    },
    model: {
      value: _vm.value.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "currency", $$v);
      },
      expression: "value.currency"
    }
  }), _c('v-select', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.billingType'),
      "hint": _vm.$t('objects.contract.customer.billingTypeHint'),
      "persistent-hint": "",
      "items": _vm.billingTypeItems,
      "item-text": "text",
      "item-value": "value",
      "outlined": ""
    },
    model: {
      value: _vm.value.type,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "type", $$v);
      },
      expression: "value.type"
    }
  }), _c('v-select', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.billingMode'),
      "hint": _vm.$t('objects.contract.customer.billingModeHint'),
      "persistent-hint": "",
      "items": _vm.billingModeItems,
      "item-text": "text",
      "item-value": "value",
      "outlined": ""
    },
    model: {
      value: _vm.value.mode,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mode", $$v);
      },
      expression: "value.mode"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.invoiceSubjectLine'),
      "hint": _vm.$t('objects.contract.customer.invoiceSubjectLineHint'),
      "outlined": ""
    },
    model: {
      value: _vm.value.invoiceSubjectLine,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "invoiceSubjectLine", $$v);
      },
      expression: "value.invoiceSubjectLine"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.purchaseOrderNumber'),
      "hint": _vm.$t('objects.contract.customer.purchaseOrderNumberHint'),
      "outlined": ""
    },
    model: {
      value: _vm.value.purchaseOrderNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "purchaseOrderNumber", $$v);
      },
      expression: "value.purchaseOrderNumber"
    }
  }), _c('v-textarea', {
    attrs: {
      "label": _vm.$t('objects.person.billingProfile.note'),
      "outlined": ""
    },
    model: {
      value: _vm.value.note,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "note", $$v);
      },
      expression: "value.note"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }